// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1QQPq","title":"Info_title__2QEjt","selects":"Info_selects__3Nxkm","requiredAsterisk":"Info_requiredAsterisk__2s-6_"};